import { CalendarDays, MessageCircle, UserRound } from 'lucide-react'
import { PROVER_SITE } from './config/site'

function openAngel() {
  if (typeof window !== 'undefined' && window.openTenantChat) {
    window.openTenantChat()
  }
}

export default function MobileActionBar() {
  return (
    <>
      <nav className="mobile-actions glass-panel" aria-label="Acciones rápidas">
        <a className="mobile-action" href={PROVER_SITE.routes.booking}>
          <CalendarDays size={20}/>
          <span>Agendar</span>
        </a>
        <button type="button" className="mobile-action" onClick={openAngel} aria-label="Abrir chat con Ángel">
          <MessageCircle size={20}/>
          <span>Contacto</span>
        </button>
        <a className="mobile-action" href={PROVER_SITE.routes.patientPortal}>
          <UserRound size={20}/>
          <span>Mi Portal</span>
        </a>
      </nav>
      <div className="mobile-actions-spacer" aria-hidden="true" />
    </>
  )
}
